import * as React from "react";

import { assertNever } from "@impero-com/common/utils/obj";

import {
    TwoMonths,
    SchedulingOccurrenceChangeForDueDateOffsetForMonthOffsetPeriod as SchedulingOccurrenceChange,
} from "api/generated/model";
import { translateTwoMonthsPeriod } from "org/control/list/utils";

import { GenericCustomDueDatesModal } from "../common/genericCustomDueDatesDialog";
import { GenericOccurrencesArray } from "../common/rulesWithArrays";
import { CustomDueDatesTypedProps } from "../types";

const ALL_OCCURRENCES: TwoMonths[] = [
    "JanuaryFebruary",
    "MarchApril",
    "MayJune",
    "JulyAugust",
    "SeptemberOctober",
    "NovemberDecember",
];

type TwoMonthsCustomDueDatesModalProps = CustomDueDatesTypedProps<TwoMonths> & {
    initialCurrentOccurrences: GenericOccurrencesArray<TwoMonths>;
};

class TwoMonthsCustomDueDatesModal extends React.Component<TwoMonthsCustomDueDatesModalProps> {
    onChange = (
        currentOccurrences: Partial<
            Record<TwoMonths, SchedulingOccurrenceChange>
        >
    ) => {
        if (this.props.type !== "EDIT") {
            throw new Error("not editable");
        }
        const { onChange } = this.props;
        ALL_OCCURRENCES.forEach((occurrence) => {
            const change = currentOccurrences[occurrence];
            if (change !== undefined) {
                onChange(occurrence, change);
            }
        });
    };

    render = () => {
        const { type, initialCurrentOccurrences } = this.props;

        let typedProps;
        switch (type) {
            case "EDIT": {
                typedProps = {
                    type: "EDIT" as const,
                    onChange: this.onChange,
                };
                break;
            }
            case "READ_ONLY": {
                typedProps = {
                    type: "READ_ONLY" as const,
                };
                break;
            }
            default: {
                return assertNever(type);
            }
        }

        return (
            <GenericCustomDueDatesModal<TwoMonths>
                {...typedProps}
                initialCurrentOccurrences={initialCurrentOccurrences}
                allOccurrences={ALL_OCCURRENCES}
                translateOccurrence={translateTwoMonthsPeriod}
                translateOccurrenceShort={translateTwoMonthsPeriod}
                interval={"TwoMonths"}
            />
        );
    };
}

export { TwoMonthsCustomDueDatesModal };
